module.exports = __webpack_public_path__ + "img/zhengshu7.040cb5a7.png";